import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import StatefulMultiSelect from "@khanacademy/react-multi-select";

export default class RequiredJobsReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate:moment().toDate(),
            endDate:moment().toDate(),
            isLoading:false,
            getInvoicedReportUrl:'/api/v1/portal/portal-admin/required-jobs-report',
            InvoicedJobsReportData:[],
            downloadReportName:'Required Jobs Report',
            selectedCustomers:[],
            customers:[],
            url: "/api/v1/portal/customers/all/for-dropdown-menu",
        };
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleCustomerSelection = this.handleCustomerSelection.bind(this);
    }
    componentDidMount() {
        let options = [];   
        return fetch(this.state.url, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
        }).then((responseText) => {
          let response = responseText.json();
          response.then((response) => {
              response.map((customer)=>{
                options.push({
                    label : customer.company.short_name+'-'+customer.name,
                    value : customer.id
                });
            });
            this.setState({
              customers: options,
              isLoading: false
            });
          });
        });
      }
    handleStartDateChange(date) {
        this.setState({startDate: date})
    }
    handleEndDateChange(date) {
        this.setState({endDate: date})
    }
    handleCustomerSelection(selectedCustomers) {
        this.setState({selectedCustomers});
    }
    handleInvoicedJobsReportGeneration(e) {
        this.setState({isLoading: true});
        let url = this.state.getInvoicedReportUrl;
        return fetch(url, {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
          body: JSON.stringify({
            customer_ids: this.state.selectedCustomers,
            start_date:moment(this.state.startDate).format("YYYY-MM-DD"),
            end_date:moment(this.state.endDate).format("YYYY-MM-DD")
          }),
        }).then((responseText) => {
          let response = responseText.json();
          response.then((response) => {
            this.setState({
                InvoicedJobsReportData: response.jobs,
                isLoading: false
            })
          });
        });
    }
    download(filename, text) {
        this.setState({isDownloading: true});
        filename = filename+' From '+moment(this.state.startDate).format("YYYY-MM-DD")+' To '+moment(this.state.endDate).format("YYYY-MM-DD")+'.csv';
        let element = document.createElement('a');
        element.setAttribute('href','data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      }
    render() {
        let invoicedJobs = [];
        const {selectedCustomers} = this.state;
        let downloadableCsvDataInvoiced = "JOB REF,SCHEDULED DROP OFF,REQUIRED DROPOFF,REG/VIN,CUSTOMER,FROM ADDRESS,FROM POSTCODE,TO ADDRESS,TO POSTCODE,DROP DAY,DRIVER,DRIVER HOMETOWN,STATUS,MILE,ESTIMATED DUREATION,DRIVER COMPLETED DATE,JOB PRICE,DRIVER PRICE,INVOICE DATE,INVOICE NUMBER\n";
        if(this.state.InvoicedJobsReportData.length > 0){
            this.state.InvoicedJobsReportData.map((currentJob, index) => {
                let joburl = "/jobs/view/"+currentJob.id;
                const pickup_address_line_1 = (currentJob.pickup_address&&currentJob.pickup_address.address_line_1)?currentJob.pickup_address.address_line_1:'';
                const pickup_postcode = (currentJob.pickup_address&&currentJob.pickup_address.postcode)?currentJob.pickup_address.postcode:'';
                const dropoff_address_line_1 = (currentJob.dropoff_address&&currentJob.dropoff_address.address_line_1)?currentJob.dropoff_address.address_line_1:'';
                const dropoff_postcode = (currentJob.dropoff_address&&currentJob.dropoff_address.postcode)?currentJob.dropoff_address.postcode:'';
                const {
                    id,
                    scheduled_dropoff_date,
                    required_dropoff_date,
                    vehicle: { registration_number },
                    customer: { name },
                    driver,
                    status = '',
                    distance_in_miles,
                    estimated_duration,
                    driver_completed_at,
                    drop_day,
                    job_price,
                    driver_price,
                    invoice_date,
                    invoice_number = ''
                } = currentJob;
                  
                invoicedJobs.push(
                    <tr key={index}>
                            <td className="job-ref-font16">
                            <a href={joburl}>{id}</a>
                            </td>
                            <td>{scheduled_dropoff_date ? moment(scheduled_dropoff_date).format("DD/MM/YY") : ""}</td>
                            <td>{required_dropoff_date ? moment(required_dropoff_date).format("DD/MM/YY") : ""}</td>
                            <td>{registration_number}</td>
                            <td>{name}</td>
                            <td>{pickup_address_line_1}</td>
                            <td>{pickup_postcode}</td>
                            <td>{dropoff_address_line_1}</td>
                            <td>{dropoff_postcode}</td>
                            <td>{drop_day}</td>
                            <td>{_.get(driver,'user.first_name','')+' '+_.get(driver,'user.last_name','')}</td>
                            <td>{_.get(driver,'home_address.town_city','')}</td>
                            <td>{status}</td>
                            <td>{distance_in_miles}</td>
                            <td>{estimated_duration}</td>
                            <td>{driver_completed_at ? moment(driver_completed_at).format("DD/MM/YY") : ""}</td>
                            <td>£{job_price}</td>
                            <td>£{driver_price}</td>
                            <td>{(invoice_date) ? moment(invoice_date).format("DD.MM.YY") : ""}</td>        
                            <td>{(invoice_number ? invoice_number : "")}</td>   
                      </tr>
                );
                
                const sanitizedPickup = pickup_address_line_1.replaceAll(",", " ");
                const sanitizedDropoff = dropoff_address_line_1.replaceAll(",", " ");
                const sanitizedTownCity = _.get(driver, 'home_address.town_city', '').replaceAll(",", " ");

                downloadableCsvDataInvoiced += `${id},${scheduled_dropoff_date ? moment(scheduled_dropoff_date).format("DD/MM/YY") : ""},${required_dropoff_date ? moment(required_dropoff_date).format("DD/MM/YY") : ""},${registration_number},${name},${sanitizedPickup},${pickup_postcode},${sanitizedDropoff},${dropoff_postcode},${drop_day},${_.get(driver, 'user.first_name', '') + ' ' + _.get(driver, 'user.last_name', '')},${sanitizedTownCity},${status},${distance_in_miles},${estimated_duration},${driver_completed_at ? moment(driver_completed_at).format("DD/MM/YY") : ""},${job_price},${driver_price},${invoice_date ? moment(invoice_date).format("DD.MM.YY") : ""},${invoice_number}\n`;
            });
        }else{
            invoicedJobs.push(
                <tr key='no-records'><td colSpan="17" className='text-center'>No Records</td></tr>
            );
        }
        
        return (
            <div className="container-fluid">
                <div className="col-md-6">
                    <h2>Required Jobs Report</h2>
                    <br/>
                </div>
                
                <div className="row">
                    <div className="col-md-1">
                        <label><h5>Select Start Date:</h5></label><br/>
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleStartDateChange} selected={this.state.startDate}/>
                    </div>
                    <div className="col-md-1">
                        <label><h5>Select End Date:</h5></label><br/>
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleEndDateChange} selected={this.state.endDate}/>
                    </div>
                    <div className="col-md-3 col-sm-12">
                        <label><h5>Select Customer</h5></label><br/>
                            <div>
                                <StatefulMultiSelect
                                    options={this.state.customers}
                                    selected={selectedCustomers}
                                    onSelectedChanged={this.handleCustomerSelection}
                                        overrideStrings={{
                                            selectSomeItems: "Select Customers...",
                                            allItemsAreSelected: "All Customers are Selected",
                                            selectAll: "Select All",
                                            search: "Search Customer",
                                        }}
                                    />
                            </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <button className="btn btn-lg btn-success invoiced-btn-margin" onClick={(e) => this.handleInvoicedJobsReportGeneration(e)}>
                                   <i className="fa fa-save"></i> Generate Required Customer Jobs Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg invoiced-btn-margin"
                                    onClick={(e) => {
                                    this.download(this.state.downloadReportName, downloadableCsvDataInvoiced);
                                  }}
                                  >
                                <i className="fa fa-download"></i> Download Required Customer Report
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3"><label className="alert alert-primary"><b>{this.state.InvoicedJobsReportData.length} jobs found..</b></label></div>             
                </div>
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl font-normal">
                                <thead className="sticky-top-without-zindex bg-light">
                                    <tr>
                                        <th>Job Ref</th>
                                        <th>Scheduled Drop Off</th>
                                        <th>Required Drop Off</th>
                                        <th>Reg/VIN</th>
                                        <th>Customer</th>
                                        <th>From Address</th>
                                        <th>From Postcode</th>
                                        <th>To Address</th>
                                        <th>To Postcode</th>
                                        <th>Drop Day</th>
                                        <th>Driver</th>
                                        <th>Driver Hometown</th>
                                        <th>Status</th>
                                        <th>Mile</th>
                                        <th>Estimated Dureation</th>
                                        <th>Driver Completed Date (drop day)</th>
                                        <th>Job price</th>
                                        <th>Driver price</th>
                                        <th>Invoice Date</th>
                                        <th>Invoice Number</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {this.state.isLoading ?
                                (<tr><td colSpan="18"><span className="add-loading-text">
                                        <i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :
                                    invoicedJobs
                                }
                                </tbody>
                            </table>
                        </div>
                        <br/><br/><br/>
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-required_jobs_report')) {
    ReactDOM.render(
        <RequiredJobsReport message_if_none = 'Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-required_jobs_report')
    );
}